var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "left" }, attrs: { id: "app" } },
    [
      _c("div", { staticClass: "mars-layout-wrapper" }, [
        _c(
          "div",
          { staticClass: "flex flex-top content" },
          [
            _c("ul", { staticClass: "navbar el-menu flex flex-box" }, [
              _c(
                "div",
                { staticClass: "afull flex flex-left flex-align-center" },
                [
                  _c("div", { staticClass: "flex-box nav-head-logo" }, [
                    _c("img", { attrs: { src: _vm.logo } }),
                    _c("span", {
                      staticStyle: {
                        display: "inline-block",
                        height: "100%",
                        "vertical-align": "middle",
                        "font-size": "0"
                      }
                    })
                  ]),
                  _vm._m(0)
                ]
              )
            ]),
            _c("keep-alive", [_c("router-view")], 1)
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-box nav-head-title" }, [
      _c("p", { staticClass: "nav-head-title-main-text" }, [
        _c("span", [_vm._v("交费大厅")]),
        _c("span", { staticClass: "nav-head-title-sub-text" }, [
          _vm._v("On-line Payment Platform")
        ])
      ]),
      _c("span", {
        staticStyle: {
          display: "inline-block",
          height: "100%",
          "vertical-align": "middle",
          "font-size": "0"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }